var _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDetectingLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 31,
    r: 24,
    stroke: "#111111",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 38C25.134 38 22 34.866 22 31C22 27.134 25.134 24 29 24",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9592 11.5C27.1291 11.5 23.8424 11.9558 19.7337 14.3633C15.6051 16.7825 12.5042 20.5375 11.0009 24.9614C10.8821 25.3112 10.7738 25.6633 10.6762 26.0173C10.7827 26.0059 10.8908 26 11.0003 26C11.5987 26 12.1562 26.1752 12.6242 26.4771C12.7062 26.1848 12.7964 25.894 12.8946 25.6049C14.2384 21.6502 17.0177 18.2728 20.7449 16.0889C24.4919 13.8933 27.4149 13.5 29.9592 13.5C30.5114 13.5 30.9592 13.0523 30.9592 12.5C30.9592 11.9477 30.5114 11.5 29.9592 11.5ZM12.0211 31.8219C11.7024 31.9372 11.3587 32 11.0003 32C10.6568 32 10.3269 31.9423 10.0195 31.836C10.121 34.1015 10.6346 36.3502 11.556 38.4771C13.4168 42.7727 16.8145 46.2816 21.1268 48.3826C25.4383 50.4832 30.3881 51.0425 35.0887 49.9635C39.7896 48.8843 43.9435 46.2345 46.797 42.479C47.1312 42.0393 47.0456 41.4119 46.6058 41.0778C46.1661 40.7436 45.5387 40.8293 45.2046 41.269C42.6426 44.6408 38.8991 47.0367 34.6412 48.0142C30.3829 48.9917 25.9004 48.4836 22.0027 46.5846C18.1058 44.686 15.0562 41.5257 13.3912 37.6821C12.5775 35.8037 12.1196 33.8205 12.0211 31.8219Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18C28.1574 18 26.0283 18.2983 23.335 19.9157C20.6416 21.533 18.6255 24.0389 17.6493 26.9828C16.6732 29.9266 16.801 33.1151 18.0099 35.9749C19.2187 38.8346 21.4293 41.1778 24.2438 42.5831C27.0584 43.9883 30.2924 44.3634 33.364 43.6408C36.4356 42.9182 39.1433 41.1454 41 38.6412",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 29,
    r: 1,
    transform: "rotate(-180 11 29)",
    fill: "#111111"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 31,
    r: 3,
    fill: "#56AB50"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 36,
    r: 0.5,
    stroke: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1211 5C30.2774 15.5103 29.0006 31.415 29.0006 31.415L52.0103 19.7187",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetectingLight);
export default __webpack_public_path__ + "static/media/icon-detecting-light.d6d44717389b20f83254fc39b7e08a2c.svg";
export { ForwardRef as ReactComponent };